type FireboltCoreConfig = {
  userName: string;
  defaultEngine: string;
  defaultDatabase: string;
};

declare global {
  interface Window {
    __FIREBOLT_CORE_CONFIG__?: Partial<FireboltCoreConfig>;
  }
}

const requireField = (
  config: Partial<FireboltCoreConfig> | undefined,
  field: keyof FireboltCoreConfig
): string => {
  const value = config?.[field];
  if (typeof value !== "string" || value.length === 0) {
    throw new Error(
      `Missing runtime config: window.__FIREBOLT_CORE_CONFIG__.${field}. ` +
        `Set the corresponding environment variable when starting the container.`
    );
  }
  return value;
};

export const getFireboltCoreConfig = (): FireboltCoreConfig => {
  const config = window.__FIREBOLT_CORE_CONFIG__;
  return {
    userName: requireField(config, "userName"),
    defaultEngine: requireField(config, "defaultEngine"),
    defaultDatabase: requireField(config, "defaultDatabase"),
  };
};
